<style>
.gradient-background {
  background: #00d301;
  background: -webkit-linear-gradient(11deg,#00d301,#36c275 50%,#00a562);
  background: linear-gradient(79deg,#00d301,#36c275 50%,#00a562);
}
.gradient-text {
  background: #00d301;
  background: -webkit-linear-gradient(11deg,#00d301,#36c275 50%,#00a562);
  background: linear-gradient(79deg,#00d301,#36c275 50%,#00a562);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  text-fill-color: transparent;
  /* -webkit-text-fill-color: transparent; */
}
.menubar__button {
  color: #fff;
}
</style>
<template>
  <div class="editor">
    <editor-menu-bubble :editor="editor">
      <div
        slot-scope="{ commands, isActive, menu }"
        class="menububble"
        :class="{ 'is-active': menu.isActive }"
        :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
      >

        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
        <v-icon color="white">format_bold</v-icon>
        </button>
        <button
         class="menubar__button"
         :class="{ 'is-active': isActive.heading({ level: 1 }) }"
         @click="commands.heading({ level: 1 })"
       >
         H1
       </button>

       <button
         class="menubar__button"
         :class="{ 'is-active': isActive.heading({ level: 2 }) }"
         @click="commands.heading({ level: 2 })"
       >
         H2
       </button>

       <button
         class="menubar__button"
         :class="{ 'is-active': isActive.heading({ level: 3 }) }"
         @click="commands.heading({ level: 3 })"
       >
         H3
       </button>
      </div>
    </editor-menu-bubble>

    <editor-content class="editor__content" :editor="editor" />
  </div>
</template>
<script>

import { Editor, EditorContent, EditorMenuBubble } from 'tiptap'
import Icon from './icon.vue'
import {
  Blockquote,
  BulletList,
  CodeBlock,
  HardBreak,
  Heading,
  ListItem,
  OrderedList,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions';



export default {
    props:['chart'],
    data: function() {
      return {
        editor: new Editor({
          extensions: [
            new Blockquote(),
            new BulletList(),
            new CodeBlock(),
            new HardBreak(),
            new Heading({ levels: [1, 2, 3] }),
            new ListItem(),
            new OrderedList(),
            new TodoItem(),
            new TodoList(),
            new Bold(),
            new Code(),
            new Italic(),
            new Link(),
            new Strike(),
            new Underline(),
            new History(),
          ],
          content: `
            <h2>
              Menu Bubble
            </h2>
            <p>
              Hey, try to select some text here. There will popup a menu for selecting some inline styles. <em>Remember:</em> you have full control about content and styling of this menu.
            </p>
          `,
        }),
      };
    },
    components : {
      'editor': Editor,
      'editor-content': EditorContent,
      'editor-menu-bubble': EditorMenuBubble,
      'icon': Icon
    },
    methods: {

    },
    computed: {

    },
    mounted: function() {

    },
    beforeDestroy() {
      this.editor.destroy()
    }
}

</script>
